















































import {
  Component, Emit, Prop, Vue, Watch,
} from 'vue-property-decorator';
import {
  find, some, assign, get,
} from 'lodash';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueMultiselect from 'vue-multiselect';

import TransactionParticipantForm from '@/components/TransactionParticipantForm.vue';
import { BankAccount } from '@/api/payment-orders';
import PartyForm from '@/components/PartyForm.vue';
import PartyModal from '@/components/PartyModal.vue';

@Component({
  name: 'ChoosePartyModal',
  components: {
    PartyModal,
    PartyForm,
    ValidationProvider,
    ValidationObserver,
    VueMultiselect,
    TransactionParticipantForm,
  },
  inheritAttrs: false,
})
export default class ChoosePartyModal extends Vue {
  @Prop({
    type: String,
    default: 'Odaberi stranku',
  })
  readonly title!: string;

  @Prop({
    type: String,
    default: 'Dodaj stranku',
  })
  readonly addPartyText!: string;

  @Prop({
    type: Array,
    default: () => [],
  })
  readonly parties!: BankAccount[];

  @Prop({
    type: Object,
    default: null,
  })
  readonly party!: Partial<BankAccount> | null;

  @Prop({
    type: Object,
    default: null,
  })
  readonly partyDefaults!: Partial<BankAccount> | null;

  @Prop({
    type: Boolean,
  })
  readonly hideIban!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly ibanOptional!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideSynesisCode!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly synesisCodeRequired!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideIsPayable!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideDirectDebitMandate!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly directDebitMandateRequired!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideCreditorSchemeId!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly creditorSchemeIdRequired!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly isLoading!: boolean;

  @Prop({
    type: Array,
    default: () => [],
  })
  readonly requiredProps!: Array<keyof BankAccount>;

  party_: Partial<BankAccount> | null = this.party;

  @Watch('party', { deep: true, immediate: true })
  onPartyChange(party: Partial<BankAccount> | null) {
    console.log('ChoosePartyModal', { party });
    this.party_ = party;
  }

  closeModalOnEsc = true;

  get selectedParty(): BankAccount | null {
    if (!this.party_?.id) {
      return null;
    }

    return find(this.parties, ['id', this.party_.id]) as BankAccount;
  }

  set selectedParty(party: BankAccount | null) {
    if (!party) {
      return;
    }

    this.party_ = party;
  }

  onAddPartyClick() {
    this.party_ = BankAccount.default();

    if (this.partyDefaults) {
      assign(this.party_, this.partyDefaults);
    }
  }

  @Emit('party:select')
  onSubmit(party: BankAccount) {
    return party;
  }

  @Emit('update:visible')
  @Emit('party:select')
  onClose() {
    return null;
  }

  @Emit('update:visible')
  onUpdateVisible(value: boolean) {
    return value;
  }

  onPartySelect(party: BankAccount) {
    if (some(this.requiredProps, (prop) => !get(party, prop))) {
      return;
    }

    this.$emit('party:select', party);
  }
}
